const breakpoints = {
    listen: function(vue) {

      let resizeId;
      let vueRootInstance = vue;

      const refreshValue = () => {
        let value = window.getComputedStyle(
            document.querySelector('body'), ':before'
        ).getPropertyValue('content').replace(/\"/g, '');
        vueRootInstance.$store.dispatch('mediaqueries/updateMediaQueryName', value);
      };

      let startedRezising = false;
      let handleSecondaryMenu = false;
      let handleCurrentItem = true;

      window.addEventListener('resize', () => {
        clearTimeout(resizeId);
        if(!startedRezising) {
          if(vueRootInstance.hasCurrentNavigation) {
            vueRootInstance.$store.dispatch('secondnavigation/setShowCurrentItem', false);
            handleCurrentItem = true;
          }
          startedRezising = true;
        }
        resizeId = setTimeout(() => {
          refreshValue();
          startedRezising = false;
          if(handleCurrentItem){
            vueRootInstance.$store.dispatch('secondnavigation/setShowCurrentItem', true);

          }
        }, 200);
      });

      refreshValue();
    }
};

export default breakpoints;



// WEBPACK FOOTER //
// ./utils/breakpoints.js